export default "__VITE_ASSET__CIkK4IK4__"